function is_test(): boolean {
    return process.env.NODE_ENV === "test"
}

// return path to static assets in dev and production. use `require()` to load static assets for testing.
// this is achieved by symlinking public static assets to a 'safe' (not included during build) location.
// a common location is /src/__tests__/
function source(asset: string, prefix?: string) {
    const path = prefix + asset
    return is_test() ? require(path) : path
}

// background: asset files for this project are stored (from the root of the repo) /public/assets.
// These asset files are not small (in file size) enough to inline without excessively bloating the
// js bundle size. However, we do want access to these files during testing. To accommodate this
// requirement, a /public/assets/ has been symlinked to /src/__tests__/assets/ (__tests__ is
// excluded in the build).
const PREFIX_FOR_TEST = is_test() ? "./__tests__" : ""
const PREFIX = process.env.PUBLIC_URL + PREFIX_FOR_TEST

// Geojson files
export const HUC_6 = source('/assets/huc_6_simplified_cleaned.geojson', PREFIX)

// Metadata files
// export const METADATA_90_M = source('/assets/90_m_metadata.json', PREFIX)
export const METADATA = source('/assets/husic_michalek_2022_metadata_with_basin_stats.json', PREFIX)
